import image1 from '../images/IAmWhatIAm.jpg';
import image2 from '../images/legendBook.jpg';
import image3 from '../images/spiderMan.jpg';


export const images = [
    { img: image1 }, 
    { img: image2 }, 
    { img: image3 }];


